module.exports = __webpack_public_path__ + "static/media/Vec vectores_TC verde.3ee574c8.svg";